module.exports = __webpack_public_path__ + "static/media/report.2cfc58df.png";